<template>
  <div class="px-12">
    <div
      class="w-full bg-theme-36 px-4 flex flex-col text-white mt-5"
      style="height: 260px;"
    >
      <div
        class="w-full mt-2 text-lg flex justify-between border-b-2 border-white pb-3"
      >
        <span>
          <a
            href="https://www.asistomedia.com"
            target="_blank"
            rel="noopener noreferrer"
            class="underline"
            >ASISTOMEDIA.COM</a
          >
          - {{ residentInformation?.house?.name }}
        </span>
        <span>
          {{
            moment()
              .tz('America/Mexico_City')
              .format('DD-MM-YYYY')
          }}
        </span>
      </div>
      <div class="w-full grid grid-cols-12 mt-2">
        <div class="col-span-8 flex flex-col">
          <div class="text-4xl border-b-2 border-white pb-2">
            Reporte bitácora de salud
          </div>
          <div class="mt-2 text-xl font-semibold">
            {{ residentInformation.full_name }}
          </div>
          <div class="mt-0.5 text-xl font-semibold">
            Fecha de nacimiento :
            {{ moment(residentInformation.birth_date).format('DD-MM-YYYY') }}
          </div>
          <div class="mt-0.5 text-xl font-semibold">
            Edad :
            {{ moment().diff(residentInformation.birth_date, 'years', false) }}
            años
          </div>
        </div>
        <div class="col-span-4 flex justify-center">
          <img
            alt="Resident Image"
            class="object-contain h-48 mb-2"
            :src="residentInformation.image_base_64"
          />
        </div>
      </div>
    </div>
    <div class="w-full grid grid-cols-12 mt-5">
      <div class="col-span-4">
        <div class="w-full flex flex-col">
          <div class="w-full mb-1">
            <div
              :style="{ background: '#5E5D5E' }"
              class="
              flex flex-col
              border-b border-gray-200
              pb-3
              pr-3
              pl-2
              pt-1
              dark:border-dark-5
              font-medium
            "
            >
              <p class="text-2xl text-white">
                Frecuencia cardiaca promedio
              </p>
              <p class="text-4xl text-right text-white">
                {{ cardiacaAverage() }}
              </p>
            </div>
          </div>
          <div class="w-full mb-1">
            <div
              :style="{ background: '#F27100' }"
              class="
              flex flex-col
              border-b border-gray-200
              pb-3
              pr-3
              pl-2
              pt-1
              dark:border-dark-5
              font-medium
            "
            >
              <p class="text-2xl text-white">
                Presión diastólica “baja” promedio
              </p>
              <p class="text-4xl text-white text-right">
                {{ diastolicaAverage() }}
              </p>
            </div>
          </div>
          <div class="w-full">
            <div
              :style="{ background: '#00A1FF' }"
              class="
              flex flex-col
              border-b border-gray-200
              pb-3
              pr-3
              pl-2
              pt-1
              dark:border-dark-5
              font-medium
            "
            >
              <p class="text-2xl text-white">
                Presión sistólica “alta” promedio
              </p>
              <p class="text-4xl text-white text-right">
                {{ sistolicaAverage() }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-span-8">
        <div class="w-full px-3">
          <img
            alt="Main chart"
            class="w-full h-96"
            :src="residentInformation.metricsData.presiones"
          />
        </div>
      </div>
    </div>
    <div class="w-full grid grid-cols-12 mt-5 gap-2">
      <div class="col-span-3 h-44 bg-theme-37">
        <div class="w-full flex flex-col px-1">
          <span class="w-full text-center text-black text-lg font-semibold">
            FRECUENCIA RESPIRATORIA
          </span>
          <div class="flex w-full justify-center">
            <div class="mt-2 circle text-theme-37 font-bold">
              {{ respiratoriaAverage() }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-span-3 h-44 bg-theme-38">
        <div class="w-full flex flex-col px-1">
          <span class="w-full text-center text-black text-lg font-semibold">
            OXIGENACIÓN PROM.
          </span>
          <div class="flex w-full justify-center">
            <div class="mt-2 circle text-theme-38 font-bold">
              {{ oxigenoAverage() }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-span-3 h-44 bg-theme-39">
        <div class="w-full flex flex-col px-1">
          <span class="w-full text-center text-black text-lg font-semibold">
            PESO<br />ACTUAL
          </span>
          <div class="flex w-full justify-center">
            <div class="mt-2 circle text-theme-39 font-bold">
              {{ pesosAverage() }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-span-3 h-44 bg-theme-40">
        <div class="w-full flex flex-col px-1">
          <span class="w-full text-center text-black text-lg font-semibold">
            GLUCOSA<br />PROM.
          </span>
        </div>
        <div class="flex w-full justify-center">
          <div class="mt-2 circle text-theme-40 font-bold">
            {{ glucosaAverage() }}
          </div>
        </div>
      </div>
    </div>
    <div class="w-full grid grid-cols-12 mt-5">
      <div class="col-span-1"></div>
      <div class="col-span-11 px-2">
        <img
          alt="Data Image"
          class="h-48"
          src="@/assets/images/inform_report.png"
        />
      </div>
    </div>
    <div class="html2pdf__page-break" />
    <div
      class="w-full bg-theme-36 px-4 flex flex-col text-white mt-5"
      style="height: 60px;"
    >
      <div class="w-full mt-2 text-lg flex justify-between pb-3">
        <span> Bitácora de salud - {{ residentInformation.full_name }} </span>
        <span>
          {{
            moment()
              .tz('America/Mexico_City')
              .format('DD-MM-YYYY')
          }}
        </span>
      </div>
    </div>
    <div class="w-full border-2 border-gray p-2">
      <h1 class="text-theme-37 font-medium w-full text-2xl">
        CARDEX
      </h1>
      <table
        class="table table-report mt-3"
        aria-describedby="administrators table"
      >
        <thead>
          <tr>
            <th id="date2" class="text-center">
              Fecha
            </th>
            <th id="nombre" class="text-center">
              Medicamento
            </th>
            <th id="residencia" class="text-center">
              Presentacion
            </th>
            <th id="date1" class="text-center">
              Dosis
            </th>
            <th id="history" class="text-center">
              Horario
            </th>
          </tr>
        </thead>
        <tbody>
          <template
            v-for="(row, index) in residentInformation.meds"
            :key="row.id"
          >
            <tr v-if="index <= 10">
              <td
                class="text-center font-medium"
                :style="{
                  background: index % 2 === 0 ? '#ededef' : 'white'
                }"
              >
                {{ moment(row.prescribed_date).format('DD-MM-YYYY') }}
              </td>
              <td
                class="text-center font-medium"
                :style="{
                  background: index % 2 === 0 ? '#ededef' : 'white'
                }"
              >
                {{ row.med_name }}
              </td>
              <td
                class="text-center font-medium"
                :style="{
                  background: index % 2 === 0 ? '#ededef' : 'white'
                }"
              >
                {{ row.presentation }}
              </td>
              <td
                class="text-center font-medium"
                :style="{
                  background: index % 2 === 0 ? '#ededef' : 'white'
                }"
              >
                {{ row.dose }}
              </td>
              <td
                class="text-center font-medium"
                :style="{
                  background: index % 2 === 0 ? '#ededef' : 'white'
                }"
              >
                {{ row.horario }}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <div class="html2pdf__page-break" />
    <div
      class="w-full bg-theme-36 px-4 flex flex-col text-white mt-5"
      style="height: 60px;"
    >
      <div class="w-full mt-2 text-lg flex justify-between pb-3">
        <span> Bitácora de salud - {{ residentInformation.full_name }} </span>
        <span>
          {{
            moment()
              .tz('America/Mexico_City')
              .format('DD-MM-YYYY')
          }}
        </span>
      </div>
    </div>
    <div class="w-full border-2 border-gray p-2">
      <h1 class="text-theme-37 font-medium w-full text-2xl">
        BITÁCORA PERSONAL
      </h1>
      <div class="w-full flex flex-col mt-5">
        <template v-for="(nota, key) in notas()" :key="key">
          <div class="w-full px-2 mb-3">
            <div class="w-full text-black font-semibold">
              Fecha: {{ nota.date }}
            </div>
            <div class="w-full text-black my-5">
              <span v-html="nota.notas"></span>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="html2pdf__page-break" />
    <div
      class="w-full bg-theme-36 px-4 flex flex-col text-white mt-5"
      style="height: 60px;"
    >
      <div class="w-full mt-2 text-lg flex justify-between pb-3">
        <span> Bitácora de salud - {{ residentInformation.full_name }} </span>
        <span>
          {{
            moment()
              .tz('America/Mexico_City')
              .format('DD-MM-YYYY')
          }}
        </span>
      </div>
    </div>
    <div class="w-full border-2 border-gray p-2">
      <div class="w-full flex flex-col mt-5">
        <template v-for="(nota, key) in notas2()" :key="key">
          <div class="w-full px-2 mb-3">
            <div class="w-full text-black font-semibold">
              Fecha: {{ nota.date }}
            </div>
            <div class="w-full text-black my-5">
              <span v-html="nota.notas"></span>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
export default {
  data() {
    return {
      moment: moment
    }
  },
  props: {
    residentInformation: {
      required: true,
      type: Object
    }
  },
  methods: {
    cardiacaAverage() {
      const result = 0
      if (this.informationsFiltered) {
        const filterResults = this.informationsFiltered
          .map(information => Number(information.cardiaca) || 0)
          .filter(data => data)
        if (filterResults.length) {
          return (
            filterResults.reduce((a, b) => a + b, 0) / filterResults.length || 0
          ).toFixed(2)
        }
      }
      return result
    },
    diastolicaAverage() {
      const result = 0
      if (this.informationsFiltered) {
        const filterResults = this.informationsFiltered
          .map(information => Number(information.diastolica) || 0)
          .filter(data => data)
        if (filterResults.length) {
          return (
            filterResults.reduce((a, b) => a + b, 0) / filterResults.length || 0
          ).toFixed(2)
        }
      }
      return result
    },
    sistolicaAverage() {
      const result = 0
      if (this.informationsFiltered) {
        const filterResults = this.informationsFiltered
          .map(information => Number(information.sistolica) || 0)
          .filter(data => data)
        if (filterResults.length) {
          return (
            filterResults.reduce((a, b) => a + b, 0) / filterResults.length || 0
          ).toFixed(2)
        }
      }
      return result
    },
    pesosAverage() {
      const result = 0
      const pesoResults = []
      if (this.residentInformation.informations) {
        for (
          let i = this.residentInformation.informations.length - 1;
          i > 0;
          i--
        ) {
          const test = this.residentInformation.informations[i].peso
          if (test != null) {
            pesoResults.push(this.residentInformation.informations[i])
          }
          if (pesoResults.length >= 30) {
            break
          }
        }
      }
      if (pesoResults.length) {
        const filterResults = pesoResults
          .map(information => Number(information.peso) || 0)
          .filter(data => data)
        if (filterResults.length) {
          return (
            (
              filterResults.reduce((a, b) => a + b, 0) / filterResults.length ||
              0
            ).toFixed(0) + ' kg'
          )
        }
      }
      return result
    },
    respiratoriaAverage() {
      const result = 0
      if (this.informationsFiltered) {
        const filterResults = this.informationsFiltered
          .map(information => Number(information.respiratoria) || 0)
          .filter(data => data)
        if (filterResults.length) {
          return (
            filterResults.reduce((a, b) => a + b, 0) / filterResults.length || 0
          ).toFixed(2)
        }
      }
      return result
    },
    oxigenoAverage() {
      const result = 0
      if (this.informationsFiltered) {
        const filterResults = this.informationsFiltered
          .map(information => Number(information.oxigeno) || 0)
          .filter(data => data)
        if (filterResults.length) {
          return (
            (
              filterResults.reduce((a, b) => a + b, 0) / filterResults.length ||
              0
            ).toFixed(1) + '%'
          )
        }
      }
      return result
    },
    glucosaAverage() {
      const result = 0
      const glucosaResults = []
      if (this.residentInformation.informations) {
        for (
          let i = this.residentInformation.informations.length - 1;
          i > 0;
          i--
        ) {
          const test = this.residentInformation.informations[i].glucosa
          if (test != null) {
            glucosaResults.push(this.residentInformation.informations[i])
          }
          if (glucosaResults.length >= 30) {
            break
          }
        }
      }
      if (glucosaResults.length) {
        const filterResults = glucosaResults
          .map(information => Number(information.glucosa) || 0)
          .filter(data => data)
        if (filterResults.length) {
          return (
            filterResults.reduce((a, b) => a + b, 0) / filterResults.length || 0
          ).toFixed(1)
        }
      }
      return result
    },
    notas() {
      const result = []
      if (this.residentInformation.informations) {
        for (
          let i = this.residentInformation.informations.length - 1;
          i > 0;
          i--
        ) {
          const notas = this.residentInformation.informations[i].notas
          if (notas != null) {
            result.push({
              notas: this.residentInformation.informations[i].notas,
              date: moment
                .utc(this.residentInformation.informations[i].day)
                .format('DD-MM-YYYY')
            })
          }
          if (result.length >= 2) {
            break
          }
        }
      }
      return result
    },
    notas2() {
      const result = []
      if (this.residentInformation.informations) {
        for (
          let i = this.residentInformation.informations.length - 3;
          i > 0;
          i--
        ) {
          const notas = this.residentInformation.informations[i].notas
          if (notas != null) {
            result.push({
              notas: this.residentInformation.informations[i].notas,
              date: moment
                .utc(this.residentInformation.informations[i].day)
                .format('DD-MM-YYYY')
            })
          }
          if (result.length >= 3) {
            break
          }
        }
      }
      return result
    }
  },
  computed: {
    informationsFiltered() {
      if (this.residentInformation.informations) {
        const tableheaders = []
        for (
          let i = this.residentInformation.informations.length - 1;
          i > 0;
          i--
        ) {
          const test = this.residentInformation.informations[i].cardiaca
          if (test != null) {
            tableheaders.push(this.residentInformation.informations[i])
          }
          if (tableheaders.length >= 30) {
            break
          }
        }
        return tableheaders.reverse()
      }
      return []
    }
  }
}
</script>
<style scoped>
.circle {
  width: 100px;
  line-height: 100px;
  border-radius: 50%;
  text-align: center;
  font-size: 24px;
  background: #ffff;
  border: 1px solid #fff;
}
</style>
